import styled from 'styled-components'
import { Theme } from 'styles/Themes'

interface Prop {
  red?: boolean
}
export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  height: 100%;

  .red-icon {
    filter: invert(13%) sepia(77%) saturate(7263%) hue-rotate(0deg)
      brightness(98%) contrast(114%);
    height: 18px;
    width: 18px;
  }
  .row {
    display: flex;
  }
  .big-red-title {
    font-size: 18px;
    font-weight: 700;
    text-align: left;
    color: #ff0000;
    margin: 0 0 24px 10px;
  }
  .black-title {
    font-size: 16px;
    font-weight: 700;
    text-align: left;
    margin: 0 0 8px 0;
    color: #1c1d22;
  }
  .black-content {
    font-size: 14px;
    font-weight: 400;
    text-align: left;
    margin: 0 0 15px 0;
    color: #1c1d22;
  }
`
export const Button = styled.button`
  border-radius: 20px;
  padding: 14px 16px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  font-family: Inter;
  font-size: 14px;
  font-weight: 700;
  text-align: left;
  background-color: transparent;
  border: ${(props: any) => {
    if (props.red) return '2px solid #FF0000'
    return '2px solid #1C1D22'
  }};
  color: ${(props: any) => {
    if (props.red) return '#FF0000'
    return '#1C1D22'
  }};
  &:hover {
    color: #ffffff;
    background-color: ${(props: Prop) => {
      if (props.red) return '#FF0000'
      return '#1C1D22'
    }};
  }
  cursor: pointer;
  .icon {
    height: 18px;
    width: 18px;
    filter: ${(props: Prop) => {
      if (props.red)
        return 'invert(13%) sepia(77%) saturate(7263%) hue-rotate(0deg) brightness(98%) contrast(114%)'
      return 'none'
    }};
  }
  &:hover .icon {
    filter: invert(95%) sepia(96%) saturate(0%) hue-rotate(137deg)
      brightness(105%) contrast(103%);
  }
`

export const InputError = styled.div`
  font-family: ${Theme.fontFamily.SECONDARY};
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0em;
  text-align: start;
  padding: 5px 0;
  width: 100%;
  margin-bottom: 15px;
  text-overflow: ellipsis;
  overflow: hidden;
  color: ${Theme.pallete.SENARY};
`
